import { render, staticRenderFns } from "./CreateReadAloudOverview.vue?vue&type=template&id=7a912595&scoped=true&"
import script from "./CreateReadAloudOverview.vue?vue&type=script&lang=js&"
export * from "./CreateReadAloudOverview.vue?vue&type=script&lang=js&"
import style0 from "./CreateReadAloudOverview.vue?vue&type=style&index=0&id=7a912595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a912595",
  null
  
)

export default component.exports